import * as types from './types';
import { loading } from 'State/actions';

export const getReimbursementRates = () => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.REIMBURSEMENT_REPORT_INITIAL_LOADING, true));

    try {
      const response = await MPWWebApi.getGeneric('ReimbursementRate');

      dispatch({
        type: types.REIMBURSEMENT_REPORT_GET_REIMBURSEMENT_RATES,
        payload: response.data,
      });
    } catch (error) {
      dispatch({
        type: types.REIMBURSEMENT_REPORT_ERROR,
        payload: error.response,
      });
    }

    dispatch(loading(types.REIMBURSEMENT_REPORT_INITIAL_LOADING, false));
  };
};

export const getAllSites = () => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.REIMBURSEMENT_REPORT_INITIAL_LOADING, true));

    try {
      const response = await MPWWebApi.getGeneric('SiteMaster');

      dispatch({
        type: types.REIMBURSEMENT_REPORT_GET_ALL_SITES,
        payload: response.data.Data,
      });
    } catch (error) {
      dispatch({
        type: types.REIMBURSEMENT_REPORT_ERROR,
        payload: error.response,
      });
    }

    dispatch(loading(types.REIMBURSEMENT_REPORT_INITIAL_LOADING, false));
  };
};

export const updateSelectedSite = (checked, siteId) => {
  return {
    type: types.REIMBURSEMENT_REPORT_UPDATE_SELECTED_SITES,
    payload: { checked: checked, siteId: siteId },
  };
};

export const updateSelectAll = checked => {
  return {
    type: types.REIMBURSEMENT_REPORT_SELECT_ALL_SITES,
    payload: checked,
  };
};

export const getReport = data => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.REIMBURSEMENT_REPORT_LOADING, true));

    try {
      const response = await MPWWebApi.postGenericInsertUpdate(
        'Reports/Reimbursement',
        data
      );
      dispatch({
        type: types.REIMBURSEMENT_REPORT_GET_REPORT,
        payload: response.data.Data ? response.data.Data : 'No Data',
      });
    } catch (error) {
      dispatch({
        type: types.REIMBURSEMENT_REPORT_ERROR,
        payload: error.response,
      });
    }

    dispatch(loading(types.REIMBURSEMENT_REPORT_LOADING, false));
  };
};

export const clearReport = () => {
  return dispatch => {
    dispatch({ type: types.REIMBURSEMENT_REPORT_CLEAR_REPORT });
  };
};



// WEBPACK FOOTER //
// ./src/pages/reimbursement/state/report/actions.js